function fetchService<T>(url: string, payload?: any): Promise<T> {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'cookie': document.cookie
    },
    body: payload ? JSON.stringify({...payload, "v":-20180620}) : "{\"payload\":{},\"v\":-20180620}",
  };

  return fetch(url, requestOptions).then(res => res.json() as T)
}

export default fetchService
